<template>
  <div class="flex flex-col h-full py-10 px-16">
    <p class="font-bold text-xl mb-5">Ranking</p>
    <div v-if="rankingList.length > 0">
      <div class="bg-gray-100">
        <div class="grid grid-cols-3">
          <div class="border border-gray-200 p-3">
            <p class="font-bold">Did</p>
          </div>
          <div class="border border-gray-200 p-3">
            <p class="font-bold">Points</p>
          </div>
          <div class="border border-gray-200 p-3">
            <p class="font-bold">Pseudo</p>
          </div>
        </div>
      </div>
      <div
        v-for="ranking in rankingList.sort((a, b) => b.points - a.points)"
        :key="ranking.did"
      >
        <div class="grid grid-cols-3">
          <div class="border border-gray-200 p-3">
            <p class="text-sm break-all">{{ ranking.did }}</p>
          </div>
          <div class="border border-gray-200 p-3">
            <p class="text-sm">{{ ranking.points }}</p>
          </div>
          <div class="border border-gray-200 p-3">
            <p class="text-sm">
              {{
                membersPseudos.find((member) => member.did === ranking.did)
                  ? membersPseudos.find((member) => member.did === ranking.did)
                      .pseudo
                  : 'N/A'
              }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <p class="font-bold text-xl my-5">All members</p>
    <div v-if="membersPseudos.length > 0">
      <div class="bg-gray-100">
        <div class="grid grid-cols-2">
          <div class="border border-gray-200 p-3">
            <p class="font-bold">Did</p>
          </div>
          <div class="border border-gray-200 p-3">
            <p class="font-bold">Pseudo</p>
          </div>
        </div>
      </div>
      <div v-for="member in membersPseudos" :key="member.did">
        <div class="grid grid-cols-2">
          <div class="border border-gray-200 p-3">
            <p class="text-sm break-all">{{ member.did }}</p>
          </div>
          <div class="border border-gray-200 p-3">
            <p class="text-sm">{{ member.pseudo }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from 'vuex';
import { computed, ref, inject } from 'vue';

export default {
  setup() {
    const store = useStore();
    const utils = inject('utils');
    const api = inject('api');

    const currentIssuerDid = computed(() => store.getters.getCurrentIssuerDid);

    const rankingList = ref([]);
    const membersPseudos = ref([]);
    async function getPointRanking() {
      api.getPointRanking(currentIssuerDid.value).then((res) => {
        rankingList.value = res.data;
      });
    }
    getPointRanking();

    async function getCommunityMembersPseudos() {
      api.getCommunityMembersPseudos().then((res) => {
        membersPseudos.value = res.data;
      });
    }
    getCommunityMembersPseudos();

    return {
      rankingList,
      membersPseudos,
    };
  },
};
</script>
